var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNameWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 11,
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0665 5.25072C16.2415 1.97968 13.0409 0.000244141 9.49916 0.000244141C5.95741 0.000244141 2.75143 1.97968 0.94265 5.25072L0.791016 5.4975L0.931819 5.74952C2.75685 9.02057 5.95741 11 9.49916 11C13.0409 11 16.2469 9.04682 18.0665 5.74952L18.2073 5.4975L18.0665 5.25072ZM9.49916 9.92365C6.45022 9.92365 3.65041 8.275 2.02575 5.4975C3.65041 2.71999 6.45022 1.07134 9.49916 1.07134C12.5481 1.07134 15.3154 2.72524 16.9671 5.4975C15.3154 8.275 12.5427 9.92365 9.49916 9.92365Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.49991 9.16659C11.778 9.16659 13.6248 7.525 13.6248 5.50001C13.6248 3.47501 11.778 1.83342 9.49991 1.83342C7.22178 1.83342 5.375 3.47501 5.375 5.50001C5.375 7.525 7.22178 9.16659 9.49991 9.16659Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameWhite);
export default __webpack_public_path__ + "static/media/name_white.94955864abf4ff1d6254e926a5db796e.svg";
export { ForwardRef as ReactComponent };